// Enum: lime.graphics.ImageChannel

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

// Imports

var $estr = require("./../../estr_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Definition

var ImageChannel = $hxEnums["lime.graphics.ImageChannel"] = { __ename__ : "lime.graphics.ImageChannel", __constructs__ : ["RED","GREEN","BLUE","ALPHA"]
  ,RED: {_hx_index:0,__enum__:"lime.graphics.ImageChannel",toString:$estr}
  ,GREEN: {_hx_index:1,__enum__:"lime.graphics.ImageChannel",toString:$estr}
  ,BLUE: {_hx_index:2,__enum__:"lime.graphics.ImageChannel",toString:$estr}
  ,ALPHA: {_hx_index:3,__enum__:"lime.graphics.ImageChannel",toString:$estr}
};

exports.default = ImageChannel;